import { collection, query, where, getDocs, doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Determines the userType based on whether the user has a hairstylist profile
 * @param {string} userId - The user's UID
 * @returns {Promise<'service'|'client'>} - 'service' if user has a hairstylist profile, 'client' otherwise
 */
export async function determineUserType(userId) {
  if (!userId) {
    return 'client';
  }

  try {
    const q = query(
      collection(db, 'hairstylists'),
      where('userId', '==', userId)
    );
    const snapshot = await getDocs(q);
    
    return snapshot.empty ? 'client' : 'service';
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error determining userType:', error);
    // Default to 'client' on error
    return 'client';
  }
}

/**
 * Updates the userType field for a user in Firestore
 * @param {string} userId - The user's UID
 * @param {import('firebase/firestore').Firestore} firestoreDb - Optional Firestore instance (defaults to db)
 * @returns {Promise<void>}
 */
export async function updateUserType(userId, firestoreDb = db) {
  if (!userId) {
    return;
  }

  try {
    const userType = await determineUserType(userId);
    
    await setDoc(
      doc(firestoreDb, 'users', userId),
      { userType },
      { merge: true } // Merge to preserve existing fields
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error updating userType:', error);
    throw error;
  }
}
